export default __webpack_public_path__ + "static/krispcallIcon-d6e5917b9ea8e02dc04610db0c87e570.svg";